export const parseTagValue = (tagValue: string): [string, string | undefined] => {
  const [id, value] = tagValue.split('-');

  return [id, value];
};
